interface InsuranceDetails {
    policy_provider: string;
    policy_number: string;
    expiration_date: string;
}

export interface CompanyDetails {
    mail: string;
    unique_code: string;
    fiscal_code: string;
    vat_number?: string;
    company_name: string;
    legal_address: string;
    legal_city: string;
    legal_postal_code: string;
    insurance_details?: InsuranceDetails;
}

export const companyDetails: CompanyDetails = {
    mail: "hqvillagesbsrl@pec.it",
    unique_code: "M5UXCR1",
    fiscal_code: "02443490509",
    vat_number: null,
    company_name: "HQVILLAGE SB SRL",
    legal_address: "Via Giordano Bruno 21",
    legal_city: "Pontedera (PI)",
    legal_postal_code: "56025",
    insurance_details: {
        policy_provider: "LLOYD'S Insurance Company S.A.",
        policy_number: "DY502401-LB",
        expiration_date: "30/05/2027",
    },
};